/**
 * Escape a string for use inside HTML text or a double-quoted attribute, for
 * markup built as a string and injected with ``dangerouslySetInnerHTML``.
 * The browser decodes the entities back, so ``select.value`` / ``dataset``
 * reads return the original string unchanged.
 */
export function escapeHtmlAttr(s: string): string {
    return s
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
